export default {
  section_title: 'Tax handling',
  inherited_from_partner: 'Inherited',
  inherited_from_region: 'Regional default',
  reset: 'Reset to inherited',
  form: {
    tax_name: {
      label: 'Tax name',
      tooltip: 'How tax is named on receipts and invoices, for example VAT or GST.',
    },
    tax_behaviour: {
      label: 'Tax handling',
      tooltip: 'Whether your menu prices already contain tax, or tax is added on top at checkout.',
      options: {
        inclusive: 'Included in menu prices',
        exclusive: 'Added at checkout',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Delivery fee tax rate',
      tooltip: 'The rate your own delivery fee is taxed at, which can differ from the rate on the food.',
    },
  },
  impact: {
    title: 'Change tax handling for your restaurants?',
    affected_one: '{{count}} restaurant follows your default and will change.',
    affected_other: '{{count}} restaurants follow your default and will change.',
    overriding_one: '{{count}} restaurant has its own setting and will keep it.',
    overriding_other: '{{count}} restaurants have their own setting and will keep them.',
    confirm: 'Change them',
  },
  buttons: {
    save: 'Save',
    cancel: 'Cancel',
  },
  toasts: {
    load_error: 'Failed to load tax settings',
    impact_error: 'Failed to check which restaurants this would change',
    impact_changed_one: 'The number of affected restaurants changed to {{count}}. Please review and save again.',
    impact_changed_other: 'The number of affected restaurants changed to {{count}}. Please review and save again.',
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
  },
};
